export default "__VITE_ASSET__DqkGjOUU__"